import {
  CORRELATION_ID_HEADER,
  getOrCreateCorrelationId,
} from '../../app/shared/service/correlation-id'

export default function setupAxios(axios: any, store: any) {
  axios.defaults.headers.Accept = 'application/json'
  axios.interceptors.request.use(
    (config: any) => {
      const {
        auth: {accessToken},
      } = store.getState()

      config.headers = config.headers || {}

      if (accessToken) {
        config.headers.Authorization = `Bearer ${accessToken}`
      }

      if (!config.headers[CORRELATION_ID_HEADER]) {
        config.headers[CORRELATION_ID_HEADER] = getOrCreateCorrelationId()
      }

      return config
    },
    (err: any) => Promise.reject(err)
  )
}
